/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getLatestCommit.defs.js'
export * as $defs from './getLatestCommit.defs.js'
